import RestService from "./RestService";

export default class ValidationService extends RestService {
  constructor() {
    super("validations");
  }

  validateAssetsNotSupportedOnAdGroup(payload) {
    console.log("validateAssetsNotSupportedOnAdGroup", payload);
    const url = this.baseUrl + "/v3/api/dev/supported-assets-check";
    return this.post(url, payload);
  }
}
